<script lang="ts" setup>
	import AvailabilityTableHeader from '@/components/table/availabilitytable/AvailabilityTableHeader.vue';
	import AvailabilityTableRow from '@/components/table/availabilitytable/AvailabilityTableRow.vue';
	import {useAppStore} from '@/store/app.store';
	import {useAvailability} from '@/store/availability.store';
	import {useRegionStore} from '@/store/region.store';
	import {useProductTableStore} from '@/store/table.store';
	import type {DynamicTableHeader} from '@/types/table';
	import {getSelectedWeek, type Product, setSelectedWeek} from 'dummen-shared';
	import {computed} from 'vue';

	defineProps<{
		tableHeaders: DynamicTableHeader;
		products: Array<Product>;
		selectedWeek: string | null;
	}>();

	const appStore = useAppStore();
	const regionStore = useRegionStore();
	const tableStore = useProductTableStore();
	const availabilityStore = useAvailability();

	const selectedRegion = computed(() => regionStore.getSelectedRegionUrlName());

	const selectedWeek = computed(() => getSelectedWeek());

	const allowedToOrder = computed(() => appStore.isAllowedToOrder(selectedRegion.value));

	const showSubstitutes = computed(() => availabilityStore.showSubstitutes);

	const noAvailabilityForRegionalWebSite = computed(() => tableStore.noAvailabilityForRegionalWebSite);

	const updateSelectedWeek = (week: string) => setSelectedWeek(week);

</script>

<template>
	<table class="catalog-overview-table catalog-overview-table--availability catalog-overview-table--order-view">
		<thead>
			<tr>
				<th data-column="tablenavigation-spacing" scope="col"></th>

				<AvailabilityTableHeader v-for="[key, title] in Object.entries(tableHeaders)"
				                         class="js-table-header"
				                         :key="key"
				                         :isSelected="key === selectedWeek"
				                         :title="title"
				                         :value="key"
				                         @on-column-click="updateSelectedWeek" />

				<th data-column="tablenavigation-spacing" scope="col"></th>
			</tr>
		</thead>

		<tbody>
			<AvailabilityTableRow v-for="(product, index) in products"
			                      :key="`${index}-${product.id}`"
			                      :row-index="index"
			                      :product="product"
			                      :allowed-to-order="allowedToOrder"
			                      :no-availability-for-regional-web-site="noAvailabilityForRegionalWebSite"
			                      :selected-week="selectedWeek"
			                      :show-substitutes="allowedToOrder && showSubstitutes" />
		</tbody>
	</table>
</template>
